<script>
  // Перенос Chip из lib/ui.tsx — пилюля-метка.
  export let tone = 'default';
  export let click = false;   // в React класс вешался при наличии onClick
  export let style = undefined;
</script>

<span class={'ui-chip' + (tone !== 'default' ? ' ' + tone : '') + (click ? ' click' : '')} {style} on:click><slot /></span>
